import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'manage-index',
    component: () => import('../views/index.vue'),
    children: [
      {
        name: 'home', // 首页
        path: '/',
        component: () => import('../views/Home/index.vue')
      },
      {
        path: '/project',
        name: 'project',
        component: () => import('../views/Project/index.vue')
      },
      {
        path: '/project-detail', // 重点项目详情
        name: 'projectDetail',
        component: () => import('../views/Project/detail.vue')
      },
      {
        path: '/news',
        name: 'news',
        component: () => import('../views/News/index.vue')
      },
      // {
      //   path: '/news-detail', // 新闻中心详情
      //   name: 'newsDetail',
      //   component: () => import('../views/News/detail.vue')
      // },
      {
        path: '/epa-detail', // 新闻中心详情
        name: 'epaDetail',
        component: () => import('../views/News/epa-detail.vue')
      },
      {
        path: '/huoxing-detail', // 新闻中心详情
        name: 'huoxingDetail',
        component: () => import('../views/News/huoxing-detail.vue')
      },
      {
        path: '/zhu-detail', // 新闻中心详情
        name: 'zhuDetail',
        component: () => import('../views/News/zhu-detail.vue')
      },
      {
        path: '/rou-detail', // 新闻中心详情
        name: 'rouDetail',
        component: () => import('../views/News/rou-detail.vue')
      },
      {
        path: '/yuzhi-detail', // 新闻中心详情
        name: 'yuzhiDetail',
        component: () => import('../views/News/yuzhi-detail.vue')
      },
      {
        path: '/jianzhu-detail', // 新闻中心详情
        name: 'jianzhuDetail',
        component: () => import('../views/News/jianzhu-detail.vue')
      },
      {
        path: '/sheshi-detail', // 新闻中心详情
        name: 'sheshiDetail',
        component: () => import('../views/News/sheshi-detail.vue')
      },
      {
        path: '/xitu-detail', // 新闻中心详情
        name: 'xituDetail',
        component: () => import('../views/News/xitu-detail.vue')
      },
      {
        path: '/chanyeyuan-detail', // 新闻中心详情
        name: 'chanyeyuanDetail',
        component: () => import('../views/News/chanyeyuan-detail.vue')
      },
      {
        path: '/jiaoyi-detail', // 新闻中心详情
        name: 'jiaoyiDetail',
        component: () => import('../views/News/jiaoyi-detail.vue')
      },
      {
        path: '/about',
        name: 'about',
        component: () => import('../views/About/index.vue')
      },
      {
        path: '/tender-info',
        name: 'tenderInfo', // 招标信息
        component: () => import('../views/TenderInfo/index.vue')
      },
      {
        path: '/tender-detail', // 招标信息详情
        name: 'tenderDetail',
        component: () => import('../views/TenderInfo/detail.vue')
      },
      {
        path: '/call-me',
        name: 'callMe', // 联系我们
        component: () => import('../views/CallMe/index.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

export default router
